// 動画生成ドメインの定数。コアの計算はここ以外の定数に依存しない。
export const VIDEO_GENERATION = {
  DEFAULT_RESOLUTION: {
    WIDTH: 1920,
    HEIGHT: 1080,
  },
  // 出力の長辺の上限。画像サイズをそのまま採用するとスマートフォンの写真
  // (4032x3024 など) が H.264 ハードウェアエンコーダーの上限を超えて失敗する
  MAX_LONG_EDGE: 1920,
  AUDIO: {
    SAMPLE_RATE: 44100,
  },
  DEFAULT_DURATION_NO_AUDIO: 3,
  TRANSITION: {
    DURATION: 0.5,
    FADE_DURATION: 0.25,
  },
} as const;
